export default __webpack_public_path__ + "static/camioneta-24487aa9247f4ae798f34b918f3832bb.png";